import { render, staticRenderFns } from "./AffordabilityCalculator.vue?vue&type=template&id=8477a3d0&scoped=true&"
import script from "./AffordabilityCalculator.vue?vue&type=script&lang=js&"
export * from "./AffordabilityCalculator.vue?vue&type=script&lang=js&"
import style0 from "./AffordabilityCalculator.vue?vue&type=style&index=0&id=8477a3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8477a3d0",
  null
  
)

export default component.exports